$(document).ready(function(){
function setCartGift(){
  window_location = String(window.location.href);
  if (window_location.indexOf("#VIPGIFT") != -1){
    document.cookie = "new_cart_offer1=true; expires=Thu, 1 Jan 2025 00:00:00 UTC; path=/";
  }
  if (window_location.indexOf("#fgic__mois") != -1){
    document.cookie = "mois_offer_gift2=true; expires=Thu, 1 Jan 2025 00:00:00 UTC; path=/";
  }
}


function emailSale(){
  window_location = String(window.location.href);
  if (window_location.indexOf("discount=EXTRA10") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=EXTRA15") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=CHECK10") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=CHECK15") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("#VIPGIFT") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1500);
  }
  if (window_location.indexOf("discount=extra10off") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=extra15off") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=BACK15") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=BACK30") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
  if (window_location.indexOf("discount=VIP20OFF") != -1){
    setTimeout(function () {
        MiniCart.openCart();
      }, 1000);
  }
}




emailSale();

function getCartGift(){
  var cookies = document.cookie.split(';');
  var cart_rule = false;
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf('new_cart_offer1') != -1){
        cart_rule = true;
      }
      cart_rule = true;
    }
    // if (cart_rule == false){
    //   $('.sc_offer_progress').hide();
    //   $('.sc_old_progress').show();
    //   $('.Slide_cart_announcment_message').hide();
    // }
    // else{
    //   $('.sc_old_progress').hide();
    //   $('.Slide_cart_announcment_message').show();
    //   $('.cart-suggestions').hide();
    // }
  $('.cart-suggestions').hide();
    return cart_rule;
}
function getCartGiftMois(){

    var cookies = document.cookie.split(';');
    var cart_rule_mois = false;
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
  
        if (cookie.indexOf('mois_offer_gift2') != -1){
          cart_rule_mois = true;
        }
        // cart_rule = true
      }
  
 

    return cart_rule_mois;

}

    setCartGift();

    
    function addSiteWideGift(){
  
        jQuery.getJSON("/cart.js", function (cart) {
            var giftId100 = 41610023043209;
            var giftInCart = 0;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].id == giftId100){
                giftInCart += cart.items[i].quantity;
              }
            }
        if (giftInCart == 0){
          var data = {
            id: giftId100,
            quantity: 1
          };
        
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              MiniCart.buildCart();
              setTimeout(function () {
                MiniCart.openCart();
              }, 1500);
            },
          });
        }
        else if (giftInCart > 0){
          var data = {
            id: giftId100,
            quantity: 1
          };
        
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: data,
            dataType: "json",
            success: function () {
              MiniCart.buildCart();
             
            },
          });
        }
      });
    }
//addSiteWideGift();
      
 //if(window.location.search.includes("item=2dff03007322413f12fbeade6c2fc995")) {
    //  addSiteWideGift();
 // }
  var isChecking = false; // A flag to prevent overlapping calls

async function checkForTresholds(){
  if (isChecking) return; // Exit if a call is already in progress

  isChecking = true; // Mark that the call is in progress

  try {
    // Wait for the response from /cart.js before continuing
    const cart = await jQuery.getJSON("/cart.js");

    var giftId100 = 41610023043209;
    var giftId150 = 41885132882057;
    var giftId0 = 42920084406409;

    var gift100Qty = 0;
    var gift150Qty = 0;
    var gift0Qty = 0;

    var totalCart = cart.total_price;

    for (var i = 0; i < cart.items.length; i++) {   
      if (cart.items[i].id == giftId100) {
        gift100Qty += cart.items[i].quantity;
      }
      if (cart.items[i].id == giftId150) {
        gift150Qty += cart.items[i].quantity;
      }
      if (cart.items[i].id == giftId0) {
        gift0Qty += cart.items[i].quantity;
      }
    }

    if (gift100Qty > 0){
      if (totalCart < 6900){
        $('.Slide_cart_checkout_button__js').hide();
        $('.Checkout_button_info_message').hide();
        $('.Checkout_button_info_message2').hide();
        $('.Checkout_button_info_message3').show();
      }
      else{
        $('.Slide_cart_checkout_button__js').show();
        $('.Checkout_button_info_message').hide();
        $('.Checkout_button_info_message2').hide();
        $('.Checkout_button_info_message3').hide();
      }
    }
    else{
      // if (totalCart < 10000){
      //   if (gift100Qty > 0){
      //     $('.Slide_cart_checkout_button__js').hide();
      //     $('.Checkout_button_info_message').show();
      //     $('.Checkout_button_info_message2').hide();
      //   }
      //   else{
      //     $('.Slide_cart_checkout_button__js').show();
      //     $('.Checkout_button_info_message').hide();
      //     $('.Checkout_button_info_message2').hide();
      //   }
      // }
      // else{
      //   $('.Slide_cart_checkout_button__js').show();
      //   $('.Checkout_button_info_message').hide();
      //   $('.Checkout_button_info_message2').hide();
      // }
    }

  } catch (error) {
    console.error("Error fetching cart data:", error);
  } finally {
    isChecking = false; // Reset the flag once the call is completed
  }
}
setInterval(function(){
  checkForTresholds();
}, 500);

// ============================================================
// FREE TENNIS CHAIN PROMO ($49 threshold, currency-safe)
// Toggle ON/OFF via Shopify Theme Settings:
//   Online Store > Themes > Customize > Theme settings
//   Section: "Free Tennis Chain Promo" -> Enable checkbox
// ============================================================
var _tennisChainRunning = false; // prevent overlapping calls
var _tennisChainThresholdPrice = null; // cached after first fetch

function freeTennisChainGift() {
  if (_tennisChainRunning) return;
  _tennisChainRunning = true;

  var promoActive    = MiniCart.item.data('tennis-chain-promo');
  var variantId      = parseInt(MiniCart.item.data('tennis-chain-variant-id'), 10);
  var $badge         = $('.tennis-chain-gift-item');

  // ── Helper: remove chain from cart ──────────────────────────
  function removeChain(callback) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: variantId, quantity: 0 },
      dataType: 'json',
      complete: function() {
        if (typeof callback === 'function') callback();
      }
    });
  }

  // ── Helper: add chain to cart ────────────────────────────────
  function addChain(callback) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      complete: function() {
        if (typeof callback === 'function') callback();
      }
    });
  }

  // ── Promo OFF: hide badge, clean up cart, done ───────────────
  if (!promoActive || promoActive === 'false' || promoActive === false || !variantId || isNaN(variantId)) {
    $badge.hide();
    if (variantId && !isNaN(variantId)) {
      jQuery.getJSON('/cart.js', function(cart) {
        var chainInCart = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id === variantId) { chainInCart = true; break; }
        }
        if (chainInCart) {
          removeChain(function() { _tennisChainRunning = false; });
        } else {
          _tennisChainRunning = false;
        }
      }).fail(function() { _tennisChainRunning = false; });
    } else {
      _tennisChainRunning = false;
    }
    return;
  }

  // ── Promo ON: fetch threshold price (cached) then act ────────
  function runWithThreshold(thresholdPrice) {
    jQuery.getJSON('/cart.js')
      .done(function(cart) {
        var chainQty = 0;
        var cartTotal = cart.total_price; // in cents

        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id === variantId) {
            chainQty += cart.items[i].quantity;
          }
        }

        // Non-chain item count (to avoid qualifying on chain alone)
        var nonChainItemCount = 0;
        for (var j = 0; j < cart.items.length; j++) {
          if (cart.items[j].id !== variantId) {
            nonChainItemCount += cart.items[j].quantity;
          }
        }

        var qualifies = (cartTotal >= thresholdPrice) && (nonChainItemCount > 0);

        if (qualifies) {
          // Show badge
          $badge.css('display', 'flex');
          if (chainQty === 0) {
            // Add chain then rebuild cart to reflect it
            addChain(function() {
              _tennisChainRunning = false;
              setTimeout(function() { MiniCart.buildCart('no'); }, 300);
            });
          } else if (chainQty > 1) {
            // Ensure only 1 chain
            jQuery.ajax({
              type: 'POST', url: '/cart/change.js',
              data: { id: variantId, quantity: 1 },
              dataType: 'json',
              complete: function() { _tennisChainRunning = false; }
            });
          } else {
            _tennisChainRunning = false;
          }
        } else {
          // Does not qualify — hide badge IMMEDIATELY for instant feedback
          $badge.hide();
          if (chainQty > 0) {
            removeChain(function() {
              _tennisChainRunning = false;
              setTimeout(function() { MiniCart.buildCart('no'); }, 300);
            });
          } else {
            _tennisChainRunning = false;
          }
        }
      })
      .fail(function() { _tennisChainRunning = false; });
  }

  // Use cached threshold price if available, otherwise fetch once and cache it
  if (_tennisChainThresholdPrice !== null) {
    runWithThreshold(_tennisChainThresholdPrice);
  } else {
    jQuery.getJSON('/products/49-product.js')
      .done(function(thresholdProduct) {
        _tennisChainThresholdPrice = thresholdProduct && thresholdProduct.variants && thresholdProduct.variants.length > 0
          ? parseInt(thresholdProduct.variants[0].price, 10)
          : 4900; // safe fallback: $49.00
        runWithThreshold(_tennisChainThresholdPrice);
      })
      .fail(function() {
        // If $49-product fetch fails, silently do nothing
        _tennisChainRunning = false;
      });
  }
}

function freeGiftFromOffer() {
  if (getCartGift() == true && getCartGiftMois() == false){
    jQuery.getJSON("/cart.js", function (cart) {
      if($('.ab-test-price').length) {
        if (cart.item_count  >= 1) {
    
           var giftId = 41930773528713;
         // var giftId = null;
          var giftQty = 0;
          var giftAddedYet = parseFloat($('.sc_offer_progress').attr('data-added'));
          
          var needs_change = 0;
    
          for (var i = 0; i < cart.items.length; i++) {
            
            if (cart.items[i].id == giftId) {
              giftQty += cart.items[i].quantity;
            }
          }

          $('.Gift_cart_item').hide();
          if (cart.total_price >= 9999 ){
            if (cart.item_count > giftQty){
              $('.Gift_cart_item').css('display', 'flex');
              var data = {
                id: giftId,
                quantity: 1,
              };
              if (giftQty  == 1){
                needs_change = 0;
              }
              else{
                needs_change = 1;
              }
            }
            else{
              var data = {
                id: giftId,
                quantity: 0,
              };
              if (giftQty  == 0){
                needs_change = 0;
              }
              else{
                needs_change = 1;
              }
            }
          }
      } }else if(!$('.offer-container').length) {
        if (cart.item_count  >= 1) {
    
           var giftId = 41930773528713;
         // var giftId = null;
          var giftQty = 0;
          var giftAddedYet = parseFloat($('.sc_offer_progress').attr('data-added'));
          
          var needs_change = 0;
    
          for (var i = 0; i < cart.items.length; i++) {
            
            if (cart.items[i].id == giftId) {
              giftQty += cart.items[i].quantity;
            }
          }
    
        
          $('.Gift_cart_item').hide();
          if (cart.total_price >= 4000 ){
            if (cart.item_count > giftQty){
              $('.Gift_cart_item').css('display', 'flex');
              var data = {
                id: giftId,
                quantity: 1,
              };
              if (giftQty  == 1){
                needs_change = 0;
              }
              else{
                needs_change = 1;
              }
            }
            else{
              var data = {
                id: giftId,
                quantity: 0,
              };
              if (giftQty  == 0){
                needs_change = 0;
              }
              else{
                needs_change = 1;
              }
            }
          }
          else{
            var data = {
              id: giftId,
              quantity: 0,
            };
            if (giftQty  == 0){
              needs_change = 0;
            }
            else{
              needs_change = 1;
            }
          }
            if (needs_change == 1){
            if (giftQty > 0) {
              jQuery.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: data,
                dataType: "json",
                success: function() {
                   
                    $('.sc_offer_progress').attr('data-added','0');
                    // If tracking is allowed and the request was successful,
                    // you may trigger your tracking events here if needed.
                }
              });
            } else {
              if (giftAddedYet == 0){
              
                jQuery.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: data,
                  dataType: "json",
                  success: function () {
    
                    $('.sc_offer_progress').attr('data-added','1');
                  },
                });
              }
              
            }
          }
          
        }
      } else {
        if (cart.item_count  >= 1) {
          var giftId = 42920084406409;
          var giftQty = 0;
          var giftAddedYet = parseFloat($('.sc_offer_progress').attr('data-added'));
          
          var needs_change = 0;
    
          for (var i = 0; i < cart.items.length; i++) {
            
            if (cart.items[i].id == giftId) {
              giftQty += cart.items[i].quantity;
            }
          }
          $('.Gift_cart_item.mystery-box-item').hide();
          $('.Gift_cart_item.free-shipping-item').css('display', 'flex');
          $('.Gift_cart_item.mystery-box-item').css('display', 'flex');
          if (cart.total_price >= 19999 ){
            if (cart.item_count > giftQty){
              var data = {
                id: giftId,
                quantity: 1,
              };
              if (giftQty == 1){
                needs_change = 0;
              }
              else{
                needs_change = 1;
              }
            } else {
              var data = {
                id: giftId,
                quantity: 0,
              };
              if (giftQty  == 0){
                needs_change = 0;
              }
              else{
                needs_change = 1;
              }
            }
          } else {
            var data = {
              id: giftId,
              quantity: 0,
            };
            if (giftQty  == 0){
              needs_change = 0;
            }
            else{
              needs_change = 1;
            } 
          }
        
          if (needs_change == 1){
            if (giftQty > 0) {
              jQuery.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: data,
                dataType: "json",
                success: function() {
              
                    $('.sc_offer_progress').attr('data-added','0');
                    // If tracking is allowed and the request was successful,
                    // you may trigger your tracking events here if needed.
                }
              });
            } else {
              if (giftAddedYet == 0){
                jQuery.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: data,
                  dataType: "json",
                  success: function () {
                   
                    $('.sc_offer_progress').attr('data-added','1');
                  },
                });
              }
              
            }
          }
        
        }
      }
    });
  }
  if (getCartGiftMois() == true ){
    $('.mois_free_gift_bar').css('display', 'flex');
    jQuery.getJSON("/cart.js", function (cart) {

      if (cart.item_count  >= 1) {
  
        var giftId = 42544238624905;
        var giftMoisQty = 0;
        var moiss_in_cart = 0;
        // var giftAddedYet = parseFloat($('.sc_offer_progress').attr('data-added'));
        
        var needs_change = 0;
  
        for (var i = 0; i < cart.items.length; i++) {
          
          if (cart.items[i].id == giftId) {
            giftMoisQty += cart.items[i].quantity;
          }

          if (String(cart.items[i].variant_title).indexOf('Moiss') != -1) {
            moiss_in_cart += cart.items[i].quantity;
          }
          if (String(cart.items[i].product_title).indexOf('Moiss') != -1) {
            moiss_in_cart += cart.items[i].quantity;
          }
        }
  
      
        // $('.Gift_cart_item').hide();

        if (moiss_in_cart > 0){
          $('.mois_free_gift_bar').addClass('active');
          var mois_text = '<p>Your gift has been added!</p>';
          if (cart.item_count > giftMoisQty){
            // $('.Gift_cart_item').css('display', 'flex');
            var data = {
              id: giftId,
              quantity: 1,
            };
            if (giftMoisQty  == 1){
              needs_change = 0;
            }
            else{
              needs_change = 1;
            }
          }
          else{
            var data = {
              id: giftId,
              quantity: 0,
            };
            if (giftMoisQty  == 0){
              needs_change = 0;
            }
            else{
              needs_change = 1;
            }
          }
        }
        else{
          $('.mois_free_gift_bar').removeClass('active');
          var mois_text = '<p>Add <strong>Moissanite jewelry</strong> to your order and receive a <strong>free gift: diamond tester.</strong></p>';
          var data = {
            id: giftId,
            quantity: 0,
          };
          if (giftMoisQty  == 0){
            needs_change = 0;
          }
          else{
            needs_change = 1;
          }
        }
  
        $('.mois_gift_html__js').html(mois_text);
        if (needs_change == 1){
          if (giftMoisQty > 0) {
            jQuery.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: data,
              dataType: "json",
              success: function() {
            
                  $('.sc_offer_progress').attr('data-added','0');
                  // If tracking is allowed and the request was successful,
                  // you may trigger your tracking events here if needed.
              }
            });
          } else {
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: data,
              dataType: "json",
              success: function () {
             
                $('.sc_offer_progress').attr('data-added','1');
              },
            });
            
          }
        }
        
      }
    });
  }
}
 

MiniCart = new Object();
MiniCart.item = null;
MiniCart.maxQuantity = 6;

MiniCart.init = function() {
  MiniCart.item = $('#shopify-section-slide-cart .mini-cart-view');
  MiniCart.buildCart();


  $('body').on('click', '.product_main--atc', function (evt) {

    

    if ($('.Moissanite_swatch_input input').is(':checked')) {
        var currentId = $('.Product_form_variant_selector__js').val();
        var currentQty = 1;
        
        var data = {
          id: currentId,
          quantity: currentQty,
        };
    
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function () {
            let action = $(this);
            let reloadTimeout = 500;
            let useLoader = 'yes';
            reloadTimeout = action.data('cart-reload-timeout');
    
            MiniCart.buildCart(useLoader);
    
            setTimeout(function () {
              MiniCart.openCart();
            }, 500);
          },
      });
    } else {
      var currentId = $('.Product_form_variant_selector__js').val();
      var currentSize = $('.product_main__form__variants[data-id="'+currentId+'"]').attr('data-size');
      var currentPrice;

      var currentSize_handle = $('.product_main__form__variants[data-id="'+currentId+'"]').attr('data-size-handle');
      var currentNewPrice;
      $('.product_main__form__variants').each(function(){
        if ($(this).attr('data-size-handle') == currentSize_handle){
          if ($(this).attr('data-material-handle') == 'moisanite'){
            currentNewPrice = $(this).attr('data-price');
            currentPrice = $(this).attr('data-price-compare');
          }
        } 
      });

      $('.mois_upgrade__size--js').html(currentSize);
      $('.mois_upgrade__price--js').html(currentPrice);
      $('.mois_upgrade__price_new--js').html(currentNewPrice);
      $('.mois_up_outer').css('display', 'flex');
    }
    

  });


  $('.mois_up_decline').click(function(){
      var currentId = $('.Product_form_variant_selector__js').val();;
      var currentQty = 1;
      
      var data = {
        id: currentId,
        quantity: currentQty,
      };
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          let action = $(this);
          let reloadTimeout = 500;
          let useLoader = 'yes';
          reloadTimeout = action.data('cart-reload-timeout');
  
          MiniCart.buildCart(useLoader);
  
          setTimeout(function () {
            MiniCart.openCart();
            
          }, 500);
        },
      });

      setTimeout(function(){
        $('.mois_up_outer').hide();
      },1000);
      
  });

  $('.mois_up_atc__btn').click(function(){

    $('.Moissanite_swatch_input input').trigger('click');
    setTimeout(function(){
      var currentId = $('.Product_form_variant_selector__js').val();;
      var currentQty = 1;
      
      var data = {
        id: currentId,
        quantity: currentQty,
      };
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          let action = $(this);
          let reloadTimeout = 500;
          let useLoader = 'yes';
          reloadTimeout = action.data('cart-reload-timeout');
  
          MiniCart.buildCart(useLoader);
  
          setTimeout(function () {
            MiniCart.openCart();
            
          }, 500);
        },
      });
    },300);
    setTimeout(function(){
      $('.mois_up_outer').hide();
    },1000);
  });

  $('body').on('click', '.button--add-to-cart, .product-item-add-to-cart, .shop-look-modal .look-product-item .add-to-cart', function (evt) {
    let action = $(this);
    let reloadTimeout = 500;
    let useLoader = 'yes';
    if (action.data('cart-reload-timeout')) {
      reloadTimeout = action.data('cart-reload-timeout');
    }

    if (action.data('cart-reload-timeout') == 'no') {
      useLoader = 'no';
    }

    evt.preventDefault;
    freeGiftFromOffer(); 
    freeTennisChainGift();
    setTimeout(function(){
      MiniCart.buildCart(useLoader);
    }, 1000);

    if (action.data('open-cart') == 'yes') {
      setTimeout(function () {
        MiniCart.openCart();
      }, 1500);
    }
  });


  // Email free gift
  if (window.location.href.indexOf("#emailFreeGift") != -1) {
    let useLoader = 'yes';
    var giftId = 41284603871369;
    var gift_in_cart = 0;
    jQuery.getJSON('/cart.js', function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId) {
          gift_in_cart += cart.items[i].quantity;
        }
      }
      if (gift_in_cart == 0 ){
        data = {
          "id": giftId,
          "quantity": 1
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function () {
           
            setTimeout(function(){
              MiniCart.buildCart(useLoader);
            }, 1000);
            setTimeout(function () {
              MiniCart.openCart();
            }, 1500);
          }
        });
      }
      else{
        data = {
          "id": giftId,
          "quantity": 1
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function () {
      
            setTimeout(function(){
              MiniCart.buildCart(useLoader);
            }, 1000);
            setTimeout(function () {
              MiniCart.openCart();
            }, 1500);
          }
        });
      }
    })
  }

  if (window.location.href.indexOf("#email150FreeGift") != -1) {
    var giftId = 41885132882057;
    var gift_in_cart = 0;
    let useLoader = 'yes';
    jQuery.getJSON('/cart.js', function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId) {
          gift_in_cart += cart.items[i].quantity;
        }
      }
      if (gift_in_cart == 0 ){
        data = {
          "id": giftId,
          "quantity": 1
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function () {
            setTimeout(function(){
              MiniCart.buildCart(useLoader);
            }, 1000);
            setTimeout(function () {
              MiniCart.openCart();
            }, 1500);
          }
        });
      }
      else{
        data = {
          "id": giftId,
          "quantity": 1
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function () {
            setTimeout(function(){
              MiniCart.buildCart(useLoader);
            }, 1000);
            setTimeout(function () {
              MiniCart.openCart();
            }, 1000);
          }
        });
      }
    })
  }

  // Adding to cart integration
  /*$(document).on("click",".button--add-to-cart",function(evt) {
    evt.preventDefault;
    setTimeout(function(){
      MiniCart.buildCart(false);
    },500);
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100430705"]);
  });*/

  $('.header-cart').click(function (evt) {
    evt.preventDefault();
    MiniCart.openCart();
  });

  $('.continue-shopping-button', MiniCart.item).click(function () {
    MiniCart.closeCart();
  })

  $('.cart-head-container .cart-head .cart-close', MiniCart.item).click(function () {
    MiniCart.closeCart();
  });

  $('.Slide_cart_overlay').click(function () {
    MiniCart.closeCart();
  });

  // Remove Cart Item
  $('body').on('click', '#shopify-section-slide-cart .mini-cart-view .cart-item .item-remove', function (evt) {
      let action = $(this);
      let cartItem = action.closest('.cart-item');

      if (!cartItem.hasClass('processing')) {
        cartItem.addClass('processing');
   
        var updateLine = "updates["+ cartItem.data('cart-item-id') +"]=0";
        if (cartItem.data('extra-items')) {
          let extra = cartItem.data('extra-items').toString().split(',');
          $.each(extra, function(index, id) {
            updateLine += "&updates["+ id +"]=0";
          });
        } 

        $.post(window.Shopify.routes.root + 'cart/update.js', updateLine, function(response){ 
          cartItem.fadeOut("fast", function() {
            MiniCart.buildCart(false);
          });
        }, "json");
      } 
  });

  $('body').on('click', '#shopify-section-slide-cart .cart-foot .checkout-button', function (evt) {
    let action = $(this);
    if (!action.hasClass('processing')) {
      action.addClass('processing');
      action.find('.button-product-price').addClass('hidden');
      action.text('Loading...');
      // window.location="/checkout";
    }
  });

  $(window).on('resize', function(){
    if (MiniCart.item.hasClass('cart-opened')) {
      MiniCart.fitCartSize();
    }
  });
}

MiniCart.fitCartSize = function() {
  let height = $(window).height();
    let cartHeadHeight = $(".cart-head-container", MiniCart.item).outerHeight();
    let cartFootHeight = $(".cart-foot", MiniCart.item).outerHeight();
    let cartContentHeight = height - cartHeadHeight - cartFootHeight;
    $(".mini-cart-content", MiniCart.item).css("height",  cartContentHeight  + "px");
};


MiniCart.openCart = function() {
  MiniCart.fitCartSize();
  MiniCart.item.addClass('cart-opened');
  MiniCart.item.animate({"right":"0px"}, 300);
  $('.Slide_cart_overlay').fadeIn(250);
  $('#reamaze-widget').hide();
};
 
MiniCart.closeCart = function() {
  MiniCart.item.animate({"right":"-100%"}, 400);
  $('.Slide_cart_overlay').fadeOut(400, function() {
    $('#reamaze-widget').show();
    MiniCart.item.removeClass('cart-opened');
  });
};

MiniCart.showItem = function(properties) {
  if (!properties._boldBuilderId) {
    return true;
  } else if (properties._boldBuilderId && (properties._boldVariantIds || properties._boldVariantNames)) {
    return true;
  } else {
    return false;
  } 
}

MiniCart.isCustomProduct = function(product) {
  if (product.template_suffix == 'custom') {
    return true;
  } else {
    return false;
  } 
}

MiniCart.resizeImage = function(src, size) {
  if (size == null) {
    return src;
  }

  if (size == 'master') {
    return src.replace(/http(s)?:/, "");
  }

  var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return (prefix[0] + "_" + size + 'x' + suffix).replace(/http(s)?:/, "")
  } else {
    return null;
  }
  return null;
}

MiniCart.generatePrice = function(item, discount) {
  var sale = '';
  var priceHtml = '';

  let price = item.original_price;
  let compare_price = item.compare_line_price;


  
  if (discount) { 
    price = item.original_price - (item.original_price * discount)
  } else {
      price = item.line_price
      if (item.is_custom == 'yes' && item.properties._boldVariantPrices) {
        let extraPrices = item.properties._boldVariantPrices.split(',');
        $.each(extraPrices, function(key, extra) {   
          price = price + parseInt(extra);
        });
      }
  }
  priceHtml += '<div class="item-price">';
  if (price < compare_price) {
    sale = 'has-sale';
    priceHtml += '<span class="price was-price compare-price"><span class="money">' + Shopify.formatMoney(compare_price, $('body').data('money-format')) + '</span></span>';
  }
  priceHtml += '<span class="price current_price ' + sale + '"><span class="money">' + Shopify.formatMoney(price, $('body').data('money-format')) + '</span></span>';
  priceHtml += '</div>';

   return priceHtml;
}

MiniCart.generateProperties = function(options, properties) {
  var propertiesHtml = '';
  $.each(options, function(name, value) {
    if (name != 'Title' && name != 'Letter Quantity') {
      propertiesHtml += '<div class="item item-property"><div class="name">' + name + '</div><div class="separator">:</div><div class="value">' + value + '</div></div>';
    }
  });

  var hasChain = false;
  $.each(properties, function(name, value) {
    var firstCharacter = name.replace(/\s/g, "").slice(0, 1);
    if (firstCharacter != '_') {
      if (name == 'Select Chain (Optional):' && value.length) {
        hasChain = true;
      }
    }
  });
  

  $.each(properties, function(name, value) {
    var firstCharacter = name.replace(/\s/g, "").slice(0, 1);
    if (firstCharacter != '_') {
      if (name == 'Input Your Text here') {
        propertiesHtml += '<div class="item item-property"><div class="name">Text</div><div class="separator">:</div><div class="value">' + value + '</div></div>';
      } else if (name == 'Select Chain (Optional):' && value.length) {
        propertiesHtml += '<div class="item item-property"><div class="name">Chain</div><div class="separator">:</div><div class="value">' + value + '</div></div>';
      } else if (name == 'Select Chain (Optional):' && !value.length) {
        // Skip
      } else if (name == 'Chain Size' && !hasChain) {
        // Skip
      } else { 
        propertiesHtml += '<div class="item item-property"><div class="name">' + name + '</div><div class="separator">:</div><div class="value">' + value + '</div></div>';
      }
    }
  
  });

  return propertiesHtml;
}

MiniCart.generateQty = function(item) {
  var qtyHtml = '';
  if (item.is_custom == 'no') {
    qtyHtml += '<div class="item item-qty">';
    qtyHtml += '<div class="Slide_cart_quantity_container"><div class="Slide_cart_quantity_min__Js action-item" data-id="' + item.id + '">-</div><div class="Slide_cart_quantity_value__Js">'+ item.quantity + '</div><div class="Slide_cart_quantity_add__Js action-item" data-id="'+ item.id + '">+</div></div>';
    qtyHtml += '</div>';
  }

  return qtyHtml;
}

MiniCart.generateQtySelection = function(item) {
  var qtyHtml = '';
  if (item.is_custom == 'no') {
    let maxQty = MiniCart.maxQuantity;
    if (item.max_qty < maxQty) {
      maxQty = item.max_qty;
    }
    qtyHtml += '<div class="item item-qty">';

    qtyHtml += '<div class="qty-select">';
    qtyHtml += '<label>Quantity</label>';
    qtyHtml += '<select class="item-qty-select">';
    for(var i = 1; i <= maxQty; i++) {
      var selected = '';
      if (i == item.quantity) {
        selected = 'selected';
      }
      qtyHtml += '<option value="'+i+'" '+selected+'>'+i+'</option>';
    }
    qtyHtml += '</select>';
    qtyHtml += '</div>';

    qtyHtml += '</div>';
  }

  return qtyHtml;
}


MiniCart.renderCartGiftItem = function(i){
  var currency = $('.currency_checker').attr('data').replace('0.00', '').replace('0,00','');
  var html = `
 `;
  return html;
}

MiniCart.renderCartItemWithoutQty = function(item, key) {
  var html = '';
  if (MiniCart.showItem(item.properties)) {
    let extra = '';
    if (item.is_custom == 'yes' && item.properties._boldVariantIds) {
      extra = item.properties._boldVariantIds;
    }
    html += '<div class="cart-item" data-cart-item-id="' + item.id + '" data-extra-items="' + extra + '">';
    if (item.image) {
      html += '<div class="cart-image"><img class="lazyload" src="' + MiniCart.resizeImage(item.image, 200) + '"></div>';
    } else {
      html += '<div class="cart-image"><div class="no-image"><svg viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;}</style></defs><title>no-image</title><path d="M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z"/><path d="M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z"/><rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32"/></svg></div></div>';
    }
    html += '<div class="item-content">';
    html += '<div class="item-head">';
    html += '<div class="title">' + item.product_title + '</div>';
    html += MiniCart.generatePrice(item);
    html += '<div class="item-remove"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><rect x="0.0693359" y="4.56958" width="10" height="1" fill="black"/><rect x="5.56836" y="0.0695801" width="10" height="1" transform="rotate(90 5.56836 0.0695801)" fill="black"/></svg></div>'
    html += '</div>';
    html += '<div class="item-details">';
    html += MiniCart.generateProperties(item.options_with_values, item.properties);
    //html += MiniCart.generateQty(item);
    html += '</div>';
    html += '</div>';
    html += '</div>';
  } 

  return html;
}

MiniCart.renderCartItem = function(item, key, discount) {
  var html = '';
  if (MiniCart.showItem(item.properties)) {
    let extra = '';
    if (item.is_custom == 'yes' && item.properties._boldVariantIds) {
      extra = item.properties._boldVariantIds;
    }
    html += '<div class="cart-item" data-cart-item-id="' + item.id + '" data-extra-items="' + extra + '">';
    if (item.image) {
      html += '<div class="cart-image"><img class="lazyload" src="' + MiniCart.resizeImage(item.image, 200) + '"></div>';
    } else {
      html += '<div class="cart-image"><div class="no-image"><svg viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;}</style></defs><title>no-image</title><path d="M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z"/><path d="M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z"/><rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32"/></svg></div></div>';
    }
    html += '<div class="item-content">';
    html += '<div class="item-head">';
    html += '<div class="title">' + item.product_title + '</div>';
    html += '<div class="item-remove"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><rect x="0.0693359" y="4.56958" width="10" height="1" fill="black"/><rect x="5.56836" y="0.0695801" width="10" height="1" transform="rotate(90 5.56836 0.0695801)" fill="black"/></svg></div>'
    html += '</div>';
    html += '<div class="item-details">';
    html += MiniCart.generateProperties(item.options_with_values, item.properties);
    //html += MiniCart.generateQty(item);
    html += '</div>';
     html += '<div class="item-footer">'
    html += MiniCart.generateQtySelection(item);
      html += MiniCart.generatePrice(item, discount);
    html += '</div>'
    html += '</div>';
    html += '</div>';
  }

  return html;
}

MiniCart.countCartItems = function(items) {
  let qty = 0;
  $.each(cart.items, function(i, item) {
    if (MiniCart.showItem(item.properties)) {
      qty = qty + item.quantity;
    }
  });

  return qty;
}

MiniCart.initSuggestions = function() {
  let suggestionsTemplate = $('#cart-suggestions-template').text().split(/\$\{(.+?)\}/g);
  $(".cart-suggestions", MiniCart.item).empty();
  $(".cart-suggestions", MiniCart.item).append(suggestionsTemplate);

  const cartSuggestionsSlider = new Swiper('#cart-suggestions-' + MiniCart.item.data('suggestions-slider-key'), {
      slidesPerView: 1,
      spaceBetween: 10,
      simulateTouch: true, 
      touchStartPreventDefault: false,
      navigation: { 
          nextEl: "#shopify-section-slide-cart .mini-cart-view .cart-suggestions .suggestions-button-next",
          prevEl: "#shopify-section-slide-cart .mini-cart-view .cart-suggestions .suggestions-button-prev",
      },
      on: { 
          init: function () {
              let total = this.wrapperEl.querySelectorAll(".swiper-slide").length;
              let currentIndex = this.realIndex + 1;
              let process = (100 / total) * currentIndex; 
              $("#shopify-section-slide-cart .mini-cart-view .cart-suggestions .product-suggestions-bar .line .progress-bar").css('width', process + '%');
          },
          slideChange: function (swiper) {
              let total = this.wrapperEl.querySelectorAll(".swiper-slide").length;
              let currentIndex = this.realIndex + 1;
              let process = (100 / total) * currentIndex; 
              $("#shopify-section-slide-cart .mini-cart-view .cart-suggestions .product-suggestions-bar .line .progress-bar").css('width', process + '%');
          },
      },
  });

  // Init Product Variations
  $("#cart-suggestions-" + MiniCart.item.data('suggestions-slider-key') + " .product-item-view").each(function() {
      let item = $(this);
      let selectKey = item.data('key');
      let product = item.data('product');

      new Shopify.OptionSelectors(selectKey, {
          product: product,
          onVariantSelected: selectCallbackItem
      });
  });

  $("#cart-suggestions-" + MiniCart.item.data('suggestions-slider-key') + " .product-item-view select.single-option-selector").select2({
    minimumResultsForSearch: -1, 
    dropdownParent: MiniCart.item,
    templateSelection: function (data, container) {
        let selectContainer = container.closest('.selector-wrapper');
        var name = $('label', selectContainer).text();
        return $(`<span class="name">${name}</span><span class="sep"> : </span><span class="value">${data?.text}</span>`);
    }
  })

  // Init Add To Cart
  $('body').on('click', "#cart-suggestions-" + MiniCart.item.data('suggestions-slider-key') + " .add-to-cart", function (e) {
    let action = $(this);
    let product = action.closest('.product-item-view');
    let key = product.data('key');

    var data = {
      "id": $('#' + key, product).val(), 
      "quantity": 1
    }

    $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post', 
        data: data,
        beforeSend: function beforeSend() {
            action.attr('disabled', 'disabled').addClass('disabled').addClass('processing');
        },
        success: function success(product) {
            action.find('.button-product-price').addClass('hidden');
            action.find('.button-text').text(action.data('added'));
            window.setTimeout(function () {
                action.find('.button-product-price').removeClass('hidden');
                action.removeAttr('disabled').removeClass('disabled').removeClass('processing').find('.button-text').text(action.data('label'));
            }, 2000);
        },
        error: function error(XMLHttpRequest) {
            action.removeAttr('disabled').removeClass('disabled').removeClass('processing');
        }
    });
  });
}

MiniCart.updateQty = function(cartItem, qty) {
  if (!cartItem.hasClass('processing')) {
    cartItem.addClass('processing');

    var data = {
      "id": cartItem.data('cart-item-id'),
      "quantity": qty
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function () {
        freeGiftFromOffer();
        MiniCart.buildCart();
      }, 
      error: function(xhr, textStatus, errorThrown) {
        cartItem.removeClass('processing');
      }
    });
  }
};



MiniCart.buildCart = function(loader='yes') {

  if (loader == 'yes') {
    $('.cart-loader', MiniCart.item).removeClass('hidden');
  }
  freeGiftFromOffer();
  freeTennisChainGift();
  setTimeout(function () {
    
    $.ajax({
      type: 'GET',
      url: '/cart?view=data',
      success: function(response) {
        cart = JSON.parse(response);

        // Shipping Progress
        var shipping_limit = MiniCart.item.data('shipping-amount') * 100;
        var total_price = cart.total_price;
        var total_compare_price = cart.total_compare_price;
      
        if (total_price < shipping_limit) {
            var amount_left = shipping_limit - total_price;
            progress_bar_percentage = 100 * total_price / shipping_limit;
            progress_bar_percentage = Math.floor(progress_bar_percentage);
            $('.shipping-bar-progress .shipping-notification span', MiniCart.item).text(Shopify.formatMoney(amount_left, $('body').data('money-format')));
            $('.shipping-bar-progress .progress', MiniCart.item).css('width', progress_bar_percentage + '%');
            $('.shipping-bar-progress', MiniCart.item).removeClass('has-free-shipping');
        } else {
          $('.shipping-bar-progress .progress', MiniCart.item).css('width', '100%');
          $('.shipping-bar-progress', MiniCart.item).addClass('has-free-shipping');
        }
        let itemsCount = MiniCart.countCartItems(cart.items);
        // Cart Count
        $('.cart-head .cart-count .count', MiniCart.item).text(itemsCount);
        $('.header-cart__count').text(itemsCount);
        $('.header-cart__count').attr('data-bind', itemsCount);

        $('.cart-content-view .cart-items', MiniCart.item).empty();
        $('.empty-cart-content', MiniCart.item).addClass('hidden');

        MiniCart.initSuggestions();


        var total_price_int = cart.total_price / 100;    
        var price_before_free_shipping = 0;
        var discount = 0.0;
        var item_count = cart.item_count - 1;
        var currency = $('.currency_checker').attr('data').replace('0.00', '').replace('0', '').replace('0,00','').replace(',00','').replace('<span class=money>', '').replace('</span>', '');
        currency = currency.trim();
        var rewards = "YOUR REWARDS: ";
        if($('.sc_offer_container').length) {
          var progress_bar_percentage = cart.item_count - 1 >= 1 ? (cart.item_count - 1) * 25 : 0;
          $('.sc_offer_progress_inner').css('width', progress_bar_percentage + '%');
          $('.sc_offer_truck svg').css('fill', '#2f2f2f');
          progress_bar_percentage = Math.floor(progress_bar_percentage);
          if (total_price_int < 50.00) {
            $('.sc_offer_heading').text("")
            $('.sc_offer_text').text("Orders above $50 get a free gift worth $20!")
            $('.sc_offer_gift svg').css('fill', '#ffffff');
            $('.sc_offer_gift_bubble').css('border', '2px solid #ffffff');
            $('.sc_offer_discount10 svg').css('fill', '#ffffff');
            $('.sc_offer_discount10_bubble').css('border', '2px solid #ffffff');
            $('.sc_offer_discount15 svg').css('fill', '#ffffff');
            $('.sc_offer_discount15_bubble').css('border', '2px solid #ffffff');
            $('.sc_offer_discount20 svg').css('fill', '#ffffff');
            $('.sc_offer_discount20_bubble').css('border', '2px solid #ffffff');
            discount = 0.0
          } else if (item_count === 1) {
            $('.sc_offer_heading').text("YOU GET A FREE GIFT!")
            $('.sc_offer_text').text("Add 1 more item to get an additional 10% Discount")
            $('.sc_offer_gift svg').css('fill', '#24aa31');
            $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount10 svg').css('fill', '#ffffff');
            $('.sc_offer_discount10_bubble').css('border', '2px solid #ffffff');
            $('.sc_offer_discount15 svg').css('fill', '#ffffff');
            $('.sc_offer_discount15_bubble').css('border', '2px solid #ffffff');
            $('.sc_offer_discount20 svg').css('fill', '#ffffff');
            $('.sc_offer_discount20_bubble').css('border', '2px solid #ffffff');
            rewards += `          
              <div class="reward-box">
                FREE GIFT
              </div>`
            discount = 0.0
          } else if (item_count === 2) {
            $('.sc_offer_heading').text("YOU GET A FREE GIFT & AN ADDITIONAL 10% OFF!")
            $('.sc_offer_text').text("Add 1 more item to get an additional 15% Discount")
            $('.sc_offer_gift svg').css('fill', '#24aa31');
            $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount10 svg').css('fill', '#24aa31');
            $('.sc_offer_discount10_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount15 svg').css('fill', '#ffffff');
            $('.sc_offer_discount15_bubble').css('border', '2px solid #ffffff');
            $('.sc_offer_discount20 svg').css('fill', '#ffffff');
            $('.sc_offer_discount20_bubble').css('border', '2px solid #ffffff');
            rewards += `          
              <div class="reward-box">
                FREE GIFT
              </div>
              <div class="reward-box">
                10% OFF
              </div>`
            discount = 0.1
          } else if (item_count === 3) {
            $('.sc_offer_heading').text("YOU GET A FREE GIFT & AN ADDITIONAL 15% OFF!")
            $('.sc_offer_text').text("Add 1 more item to get an additional 20% Discount")
            $('.sc_offer_gift svg').css('fill', '#24aa31');
            $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount10 svg').css('fill', '#24aa31');
            $('.sc_offer_discount10_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount15 svg').css('fill', '#24aa31');
            $('.sc_offer_discount15_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount20 svg').css('fill', '#ffffff');
            $('.sc_offer_discount20_bubble').css('border', '2px solid #ffffff');
            discount = 0.15
            rewards += `          
            <div class="reward-box">
              FREE GIFT
            </div>
            <div class="reward-box">
              15% OFF
            </div>`
          } else {
            $('.sc_offer_heading').text("YOU GET A FREE GIFT & AN ADDITIONAL 20% OFF!")
            $('.sc_offer_text').text("")
            $('.sc_offer_gift svg').css('fill', '#24aa31');
            $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount10 svg').css('fill', '#24aa31');
            $('.sc_offer_discount10_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount15 svg').css('fill', '#24aa31');
            $('.sc_offer_discount15_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_discount20 svg').css('fill', '#24aa31');
            $('.sc_offer_discount20_bubble').css('border', '2px solid #24aa31');
            discount = 0.2;
            rewards += `          
            <div class="reward-box">
              FREE GIFT
            </div>
            <div class="reward-box">
              20% OFF
            </div>`
          }
  
          if(item_count >= 1) {
            $('.rewards-wrapper').html(rewards)
          }
        } else if($('.offer-container').length) {
          var progress_bar = total_price_int < 49.99 ? total_price_int * 35 / 100 : total_price_int * 100 / 200;
          $('.sc_offer_progress_inner').css('width', `${progress_bar < 100 ? progress_bar : 100}%`);
          if (total_price_int < 49.99) {
            $('.free-shipping-item .gift-container .gift-status').html(`
              <div class="gift-status">
                <div class="locker-container gift-wrapper">
                  <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 3.47222V4.44444H8.61111C8.97947 4.44444 9.33274 4.59077 9.5932 4.85124C9.85367 5.11171 10 5.46498 10 5.83333V10.2778C10 10.6461 9.85367 10.9994 9.5932 11.2599C9.33274 11.5203 8.97947 11.6667 8.61111 11.6667H1.38889C1.02053 11.6667 0.667263 11.5203 0.406796 11.2599C0.146329 10.9994 0 10.6461 0 10.2778V5.83333C0 5.46498 0.146329 5.11171 0.406796 4.85124C0.667263 4.59077 1.02053 4.44444 1.38889 4.44444H1.66667V3.47222C1.66667 1.58056 3.05722 0 5 0C6.55111 0 7.76167 1.01389 8.17667 2.39444C8.19394 2.44725 8.20047 2.50297 8.19589 2.55833C8.19131 2.6137 8.1757 2.66759 8.14998 2.71683C8.12427 2.76607 8.08896 2.80968 8.04615 2.84508C8.00334 2.88048 7.95387 2.90696 7.90067 2.92296C7.84748 2.93897 7.79161 2.94417 7.73637 2.93827C7.68114 2.93237 7.62763 2.91548 7.57902 2.8886C7.5304 2.86171 7.48765 2.82538 7.45328 2.78174C7.41891 2.73809 7.39362 2.68801 7.37889 2.63444C7.06111 1.57778 6.155 0.833333 5 0.833333C3.56778 0.833333 2.5 1.98889 2.5 3.47222ZM0.833333 5.83333V10.2778C0.833333 10.4251 0.891865 10.5664 0.996052 10.6706C1.10024 10.7748 1.24155 10.8333 1.38889 10.8333H8.61111C8.75845 10.8333 8.89976 10.7748 9.00395 10.6706C9.10814 10.5664 9.16667 10.4251 9.16667 10.2778V5.83333C9.16667 5.68599 9.10814 5.54468 9.00395 5.4405C8.89976 5.33631 8.75845 5.27778 8.61111 5.27778H1.38889C1.24155 5.27778 1.10024 5.33631 0.996052 5.4405C0.891865 5.54468 0.833333 5.68599 0.833333 5.83333Z" fill="white"/>
                  </svg>
                  <p class="gift-text">$${(49.99 - total_price_int).toFixed(2)} away from FREE shipping</p>
                </div>
              </div>
            `);
            
            $('.free-shipping-item').css('border-color', '#959595');
            $('.free-shipping-item .gift-container .Slide_cart_price').css('color', '#000');
            $('.sc_offer_truck svg').css('fill', '#2f2f2f');
            $('.sc_offer_truck_bubble').css('border', '2px solid #2f2f2f');
            $('.free-shipping-item .gift-container .Slide_cart_item_variant').html(`Add $${(49.99 - total_price_int).toFixed(2)} to your order to get free shipping.`);
            $('.free-shipping-item .gift-container .Slide_cart_price span.money.left-side-price').css('color', 'black');
          } else {
            $('.sc_offer_truck svg').css('fill', '#24aa31');
            $('.sc_offer_truck_bubble').css('border', '2px solid #24aa31');
            $('.free-shipping-item .gift-container .gift-status').html(`<span class="Slide_Cart_gift_badge" style="background: #24aa31;">FREE GIFT</span>`);
            $('.free-shipping-item').css('border-color', '#24aa31');
            $('.free-shipping-item .gift-container .Slide_cart_item_variant').html(`You've unlocked FREE shipping!`);
            $('.free-shipping-item .gift-container .Slide_cart_price span.money.left-side-price').css('color', '#24aa31');
          }
          if(total_price_int < 199.99) {
            $('.mystery-box-item .gift-container .gift-status').html(`
            <div class="gift-status">
              <div class="locker-container-mystery gift-wrapper">
                <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 3.47222V4.44444H8.61111C8.97947 4.44444 9.33274 4.59077 9.5932 4.85124C9.85367 5.11171 10 5.46498 10 5.83333V10.2778C10 10.6461 9.85367 10.9994 9.5932 11.2599C9.33274 11.5203 8.97947 11.6667 8.61111 11.6667H1.38889C1.02053 11.6667 0.667263 11.5203 0.406796 11.2599C0.146329 10.9994 0 10.6461 0 10.2778V5.83333C0 5.46498 0.146329 5.11171 0.406796 4.85124C0.667263 4.59077 1.02053 4.44444 1.38889 4.44444H1.66667V3.47222C1.66667 1.58056 3.05722 0 5 0C6.55111 0 7.76167 1.01389 8.17667 2.39444C8.19394 2.44725 8.20047 2.50297 8.19589 2.55833C8.19131 2.6137 8.1757 2.66759 8.14998 2.71683C8.12427 2.76607 8.08896 2.80968 8.04615 2.84508C8.00334 2.88048 7.95387 2.90696 7.90067 2.92296C7.84748 2.93897 7.79161 2.94417 7.73637 2.93827C7.68114 2.93237 7.62763 2.91548 7.57902 2.8886C7.5304 2.86171 7.48765 2.82538 7.45328 2.78174C7.41891 2.73809 7.39362 2.68801 7.37889 2.63444C7.06111 1.57778 6.155 0.833333 5 0.833333C3.56778 0.833333 2.5 1.98889 2.5 3.47222ZM0.833333 5.83333V10.2778C0.833333 10.4251 0.891865 10.5664 0.996052 10.6706C1.10024 10.7748 1.24155 10.8333 1.38889 10.8333H8.61111C8.75845 10.8333 8.89976 10.7748 9.00395 10.6706C9.10814 10.5664 9.16667 10.4251 9.16667 10.2778V5.83333C9.16667 5.68599 9.10814 5.54468 9.00395 5.4405C8.89976 5.33631 8.75845 5.27778 8.61111 5.27778H1.38889C1.24155 5.27778 1.10024 5.33631 0.996052 5.4405C0.891865 5.54468 0.833333 5.68599 0.833333 5.83333Z" fill="white"/>
                </svg>
                <p class="gift-text">$${(199.99 - total_price_int).toFixed(2)} away from FREE Mystery box</p>
              </div>
            </div>
          `);
          $('.sc_offer_diamond svg').css('fill', '#2f2f2f');
          $('.sc_offer_diamond_bubble').css('border', '2px solid #2f2f2f');
          $('.mystery-box-item').css('border-color', '#959595');
          $('.mystery-box-item .gift-container .Slide_cart_price').css('color', '#000');
            $('.mystery-box-item .gift-container .Slide_cart_price span.money.left-side-price').css('color', 'black');
        } else {
          $('.sc_offer_diamond svg').css('fill', '#24aa31');
          $('.sc_offer_diamond_bubble').css('border', '2px solid #24aa31');
          $('.mystery-box-item .gift-container .gift-status').html(`<span class="Slide_Cart_gift_badge" style="background: #24aa31;">FREE GIFT</span>`);
          $('.mystery-box-item').css('border-color', '#24aa31');
          $('.mystery-box-item .gift-container .Slide_cart_price span.money.left-side-price').css('color', '#24aa31');
        }
        } else if($('.ab-test-price').length){
           if (total_price_int < 49.99) {

             $('.Slide_cart_item_line.Gift_cart_item').hide()
           }
           if (total_price_int >= 49.99) {

             $('.Slide_cart_item_line.Gift_cart_item').show()
           }
          if (total_price_int < 175.00) {
            price_before_free_shipping = (175.00 - total_price_int).toFixed(2);
            let price_before_gift = total_price_int < 99 ? (99.00 - total_price_int).toFixed(2) : null;
            $('.Slide_cart_announcment_message').html(`You’re ${currency.trim()}${price_before_free_shipping} away from FREE shipping! ${price_before_gift > 0 ? `<br/> You’re ${currency.trim()}${price_before_gift} away from a free gift worth $20!` : ``}`);
            var progress_bar_percentage_gift = 100 * 99.99 / 175;
            $('.sc_offer_progress_inner').css('width', progress_bar_percentage + '%');
            $('.sc_offer_truck svg').css('fill', '#2f2f2f');
            if (total_price_int < 49.00){
              $('.sc_offer_gift svg').css('fill', '#2f2f2f');
              $('.sc_offer_truck_bubble').css('border', '2px solid #2f2f2f');
              $('.sc_offer_gift_bubble').css('border', '2px solid #2f2f2f');
            }
            else{
              $('.sc_offer_gift svg').css('fill', '#24aa31');
              $('.sc_offer_truck_bubble').css('border', '2px solid #2f2f2f');
              $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
            }
          }
          else{
            $('.Slide_cart_announcment_message').text('You’ve unlocked FREE shipping!');
            $('.sc_offer_progress_inner').css('width', '100%');
            $('.sc_offer_truck svg').css('fill', '#24aa31');
            $('.sc_offer_gift svg').css('fill', '#24aa31');
            $('.sc_offer_truck_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
            $('.sc_offer_gift svg').css('left', progress_bar_percentage_gift+'%');
          }
        } else {
          // ── 3-milestone progress bar ──────────────────────────────────
          // 🎁 Cloth  = $40   (27% of $150 bar)
          // ⛓️ Chain  = $99   (66% of $150 bar)
          // 🚚 Truck  = $150  (100% of $150 bar)
          var clothThreshold = 40.00;
          var chainThreshold = 49.00;
          var shipThreshold  = 150.00;

          var promoActive  = MiniCart.item.data('tennis-chain-promo');
          var chainEnabled = promoActive && promoActive !== 'false' && promoActive !== false;

          // Progress bar fills relative to $150
          var progress = Math.min(total_price_int / shipThreshold * 100, 100);
          $('.sc_offer_progress_inner').css('width', progress + '%');

          // Gift icon (cloth) — original position ~27% proportional on $150 bar
          if (total_price_int >= clothThreshold) {
            $('.sc_offer_gift svg').css('fill', '#24aa31');
            $('.sc_offer_gift_bubble').css('border', '2px solid #24aa31');
          } else {
            $('.sc_offer_gift svg').css('fill', '#2f2f2f');
            $('.sc_offer_gift_bubble').css('border', '2px solid #2f2f2f');
          }

          // Chain icon — show/hide based on promo, colour based on threshold
          if (chainEnabled) {
            $('.sc_offer_chain').show();
            if (total_price_int >= chainThreshold) {
              $('.sc_offer_chain svg').css('fill', '#24aa31');
              $('.sc_offer_chain_bubble').css('border', '2px solid #24aa31');
            } else {
              $('.sc_offer_chain svg').css('fill', '#2f2f2f');
              $('.sc_offer_chain_bubble').css('border', '2px solid #2f2f2f');
            }
          } else {
            $('.sc_offer_chain').hide();
          }

          // Truck icon (shipping)
          if (total_price_int >= shipThreshold) {
            $('.sc_offer_truck svg').css('fill', '#24aa31');
            $('.sc_offer_truck_bubble').css('border', '2px solid #24aa31');
          } else {
            $('.sc_offer_truck svg').css('fill', '#2f2f2f');
            $('.sc_offer_truck_bubble').css('border', '2px solid #2f2f2f');
          }

          // ── Single dynamic message ────────────────────────────────────
          if (total_price_int >= shipThreshold) {
            // Everything unlocked
            if (chainEnabled) {
              $('.Slide_cart_announcment_message').html("You've unlocked FREE Tennis Chain<br>& FREE Shipping");
            } else {
              $('.Slide_cart_announcment_message').html("You've unlocked FREE Shipping");
            }
          } else if (total_price_int >= chainThreshold) {
            // Chain unlocked, shipping still needed
            var toShipping = (shipThreshold - total_price_int).toFixed(2);
            if (chainEnabled) {
              $('.Slide_cart_announcment_message').html("FREE TENNIS Chain unlocked!<br>Add " + currency + toShipping + " more for FREE Shipping");
            } else {
              $('.Slide_cart_announcment_message').html("Add " + currency + toShipping + " more for FREE Shipping");
            }
          } else if (total_price_int >= clothThreshold) {
            // Cloth unlocked, chain + shipping still needed
            var toChain    = (chainThreshold - total_price_int).toFixed(2);
            var toShipping = (shipThreshold - total_price_int).toFixed(2);
            if (chainEnabled) {
              $('.Slide_cart_announcment_message').html("You’re " + currency + toChain + " Away From FREE TENNIS Chain");
            } else {
              $('.Slide_cart_announcment_message').html("Add " + currency + toShipping + " for FREE Shipping");
            }
          } else {
            // Nothing unlocked yet
            var toCloth    = (clothThreshold - total_price_int).toFixed(2);
            var toChain    = (chainThreshold - total_price_int).toFixed(2);
            var toShipping = (shipThreshold - total_price_int).toFixed(2);
            if (chainEnabled) {
              $('.Slide_cart_announcment_message').html("You’re " + currency + toChain + " Away From FREE TENNIS Chain");
            } else {
              $('.Slide_cart_announcment_message').html("Add " + currency + toShipping + " for FREE Shipping");
            }
          }
        }


        if (cart.item_count > 0) {
          var tennisChainVariantId = String(MiniCart.item.data('tennis-chain-variant-id'));
          $.each(cart.items, function(i, item) {

            if (cart.items[i].id == '41930773528713'){
              // $('.cart-content-view .cart-items', MiniCart.item).append(MiniCart.renderCartGiftItem(i))
            }
            else if (cart.items[i].id == '41284603871369' || cart.items[i].id == '41885132882057' || cart.items[i].id == '42920084406409' || String(cart.items[i].id) == tennisChainVariantId){
              $('.cart-content-view .cart-items', MiniCart.item).append(MiniCart.renderCartItemWithoutQty(item, i))
            }
            else{
              $('.cart-content-view .cart-items', MiniCart.item).append(MiniCart.renderCartItem(item, i, discount))
            }
              
          });


          // Init Qty Select
          $(".cart-content-view .cart-items select.item-qty-select", MiniCart.item).select2({
            minimumResultsForSearch: -1, 
            dropdownParent: MiniCart.item,
            templateSelection: function (data, container) {
                let selectContainer = container.closest('.qty-select');
                var name = $('label', selectContainer).text();
                return $(`<span class="name">${name}</span><span class="sep"> : </span><span class="value">${data?.text}</span>`);
            }
          });

          $(".cart-content-view .cart-items select.item-qty-select", MiniCart.item).on('change', function() {
            let select = $(this);
            let qty = $(this).find(":selected").val();
            let item = select.closest('.cart-item');

            MiniCart.updateQty(item, qty);
            freeGiftFromOffer();
            freeTennisChainGift();
          });

          $('.cart-foot .checkout-button .button-product-price .current_price', MiniCart.item).html('<span class="money">' + Shopify.formatMoney(total_price - total_price * discount, $('body').data('money-format')) + '</span>');
          $('#slide-cart-subtotal', MiniCart.item).html('<span class="money">' + Shopify.formatMoney(total_compare_price, $('body').data('money-format')) + '</span>');
          $('#slide-cart-discount', MiniCart.item).html('<span class="money"> -' + Shopify.formatMoney(total_compare_price - total_price, $('body').data('money-format')) + '</span>');
          $('#slide-cart-total', MiniCart.item).html('<span class="money">' + Shopify.formatMoney(total_price - total_price * discount, $('body').data('money-format')) + '</span>');
          if (total_price < total_compare_price) {
            $('.cart-foot .checkout-button .button-product-price .compare-price', MiniCart.item).removeClass('hidden').html('<span class="money">' + Shopify.formatMoney(total_compare_price, $('body').data('money-format')) + '</span>');
          } else {
            $('.cart-foot .checkout-button .button-product-price .compare-price', MiniCart.item).addClass('hidden')
          }

          MiniCart.item.removeClass('empty-cart');
          $('.cart-foot', MiniCart.item).removeClass('hidden');
          $('.shipping-bar-progress', MiniCart.item).removeClass('hidden');

          MiniCart.fitCartSize();

          setTimeout(function () {
            $('.cart-loader', MiniCart.item).fadeOut("fast", function() {
              $('.cart-loader', MiniCart.item).addClass('hidden');
            });
          }, 1000);
        } else {
          // Empty Cart
          $('.cart-foot', MiniCart.item).addClass('hidden');
          $('.shipping-bar-progress', MiniCart.item).addClass('hidden');
          MiniCart.item.addClass('empty-cart');
          $('.empty-cart-content', MiniCart.item).removeClass('hidden');
          MiniCart.fitCartSize();

          setTimeout(function () {
            $('.cart-loader', MiniCart.item).fadeOut("fast", function() {
              $('.cart-loader', MiniCart.item).addClass('hidden');
            });
          }, 1000);
        }
      },
      error: function(status) {
        console.warn( 'ERROR', status );
      }
    });
  }, 1000); 
}
});

$(document).ready(function(){
  MiniCart.init();


  $('.Prepurchase_upsell_close_button').click(function(){
    $('.Prepurchase_upsell_overlay').hide();
    if($('.sc_offer_container').length) {
      jQuery.getJSON('/cart.js', function (cart) {
        var discountCode = ""
        var cartCount = cart.item_count - 1;
        if (cartCount === 2) {
          discountCode = "10_percent"
        } else if(cartCount === 3) {
          discountCode = "15_percent"
        } else if(cartCount >= 4) {
          discountCode = "20_percent"
        }
        window.location.href = `/checkout${cart.item_count >= 2 ? `?discount=${discountCode}`: ``}` ;
      })
    } else if($('.offer-container').length) {
       jQuery.getJSON('/cart.js', function (cart) {
        var totalCart = cart.total_price;
        if (totalCart >= 9999) {
          var discountCode = "free_shipping"
          window.location.href = `/checkout${cart.item_count >= 2 ? `?discount=${discountCode}`: ``}` ;
        } 
      })
    } else {
      window.location.href = '/checkout';
    }

  });

  $('.Prepurchase_upsell_deline').click(function(){
    $('.Prepurchase_upsell_deline').text('Loading...');
    if($('.sc_offer_container').length) {
      jQuery.getJSON('/cart.js', function (cart) {
        var discountCode = ""
        var cartCount = cart.item_count - 1;
        if (cartCount === 2) {
          discountCode = "10_percent"
        } else if(cartCount === 3) {
          discountCode = "15_percent"
        } else if(cartCount >= 4) {
          discountCode = "20_percent"
        }
        window.location.href = `/checkout${cart.item_count >= 2 ? `?discount=${discountCode}`: ``}` ;
      })
    } else if($('.offer-container').length) {
       jQuery.getJSON('/cart.js', function (cart) {
        var totalCart = cart.total_price;
        if (totalCart >= 9999) {
          var discountCode = "free_shipping"
          window.location.href = `/checkout${cart.item_count >= 2 ? `?discount=${discountCode}`: ``}` ;
        } 
      })
    } else {
      window.location.href = '/checkout';
    }


  });


  $('.Slide_cart_checkout_button__js').click(function (evt) {

    evt.preventDefault();

      jQuery.getJSON('/cart.js', function (cart) {
        var upsell_in_cart = 0;
        var upsell_id = $('.Prepurchase_upsell_add_button').attr('data-id');
        for (var i = 0; i < cart.items.length; i++) {
          if(upsell_id == cart.items[i].id){
            upsell_in_cart += cart.items[i].quantity;
          }
        }
        var upsell_visible = $('.Prepurchase_upsell_overlay').attr('data');
        if (upsell_visible == 'visible'){
            $('.Prepurchase_upsell_overlay').css('display', 'flex');
            startUpsellCountdown();
            // window.location="/checkout";
        }
        else{
          // window.location="/checkout";
        }
      });
  });

  $('.Prepurchase_upsell_add_button').click(function(){
    var currentId = $(this).attr('data-id');
    var data = {
      "id": currentId,
      "quantity": 1
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        setTimeout(function(){
           if($('.sc_offer_container').length) {
      jQuery.getJSON('/cart.js', function (cart) {
        var discountCode = ""
        var cartCount = cart.item_count - 1;
        if (cartCount === 2) {
          discountCode = "10_percent"
        } else if(cartCount === 3) {
          discountCode = "15_percent"
        } else if(cartCount >= 4) {
          discountCode = "20_percent"
        }
        window.location.href = `/checkout${cart.item_count >= 2 ? `?discount=${discountCode}`: ``}` ;
      })
    } else if($('.offer-container').length) {
       jQuery.getJSON('/cart.js', function (cart) {
        var totalCart = cart.total_price;
        if (totalCart >= 9999) {
          var discountCode = "free_shipping"
          window.location.href = `/checkout${cart.item_count >= 2 ? `?discount=${discountCode}`: ``}` ;
        } 
      })
    } else {
      window.location.href = '/checkout';
    }
        },500);
      }
    });
    $('.Prepurchase_upsell_add_button').text('Loading...');
    
  });

  function startUpsellCountdown(){
    var timerContainer = $(".Prepurchase_timer_js");
    var minutesContainer = timerContainer.find(".minutes");
    var secondsContainer = timerContainer.find(".seconds");

    var minutes = parseInt(minutesContainer.text());
    var seconds = parseInt(secondsContainer.text());

    var countdown = setInterval(function() {
        if (minutes == 0 && seconds == 0) {
            clearInterval(countdown);
            alert("Time's up!");
        } else {
            if (seconds == 0) {
                minutes--;
                seconds = 59;
            } else {
                seconds--;
            }

            // Update the timer display
            minutesContainer.text(minutes < 10 ? "0" + minutes : minutes);
            secondsContainer.text(seconds < 10 ? "0" + seconds : seconds);
        }
    }, 1000);
  }

// Function to check and hide elements
    function checkAndHideElements() {
        // Select all parent elements
        const selectElements = document.querySelectorAll('.select2-selection--single');
        
        selectElements.forEach(function(selectElement) {
            // Find the child element
            const renderedElement = selectElement.querySelector('.select2-selection__rendered');
            
            // Check if the child element is empty
            if (renderedElement && renderedElement.textContent.trim() === '') {
                // Hide the parent element if child is empty
                selectElement.style.display = 'none';
            } else {
                // Show the parent element if child is not empty
                selectElement.style.display = '';
            }
        });
    }

    // Initial check
    checkAndHideElements();

    // Set up a MutationObserver to monitor changes in the child element's content
    const observer = new MutationObserver(checkAndHideElements);

    // Observe changes in the entire document or you can narrow it down
    const config = { childList: true, subtree: true, characterData: true };

    // Start observing the document for changes
    observer.observe(document.body, config);
});
